"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const template_parser_1 = require("@osmosys/template-parser");
const utils_1 = require("@osmosys/utils");
const react_1 = tslib_1.__importDefault(require("react"));
const runStepOnElement_1 = require("./runStepOnElement");
const constants_1 = require("../../constants");
const react_if_1 = require("react-if");
const steps_1 = require("./steps");
exports.runStepsOnRootElement = ({ steps, dispatch, createScreenshot, client, contentStr, el, onChange, log, checkIfMounted, linkToPost, }, parentTimestamp) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let newEl = el;
    if (!checkIfMounted()) {
        utils_1.logger.warn('runSteps | Exiting (1) because component is no longer mounted');
        return newEl;
    }
    // Slow things down
    yield new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, 1 * 500);
    });
    const opts = {
        checkIfMounted,
        client,
        contentStr,
        createScreenshot,
        dispatch,
        el: newEl,
        linkToPost,
        log,
        onChange,
        steps,
    };
    yield ((_a = steps) === null || _a === void 0 ? void 0 : _a.reduce((stepResponses, step) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const arr = yield stepResponses;
        if (!checkIfMounted()) {
            utils_1.logger.warn('runSteps | Exiting (2) because component is no longer mounted');
            return arr;
        }
        // Slow things down
        yield new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 1 * 50);
        });
        parentTimestamp = parentTimestamp || new Date();
        if ('converterMessage' in step) {
            log(step.level, {
                message: react_1.default.createElement(react_1.default.Fragment, null, step.converterMessage),
                parentTimestamp,
                plainTextMessage: step.converterMessage,
            });
            return arr;
        }
        const meta = constants_1.CONVERSION_STEP_META[step.type];
        const displayStep = meta && meta.activeTense;
        log('subheader', {
            message: (react_1.default.createElement(react_1.default.Fragment, null,
                "Running conversion step #",
                step.order + 1,
                ' ',
                react_1.default.createElement(react_if_1.When, { condition: !!step.name },
                    "\"",
                    step.name,
                    "\" (",
                    meta.displayName,
                    ")"),
                react_1.default.createElement(react_if_1.When, { condition: !step.name },
                    " (",
                    meta.displayName,
                    ")"))),
            parentTimestamp,
            plainTextMessage: `Running conversion step ${step.order + 1} "${step.name}"`,
        });
        if (step.paused) {
            log('debug', {
                message: react_1.default.createElement(react_1.default.Fragment, null, "Skipping because this step is paused..."),
                parentTimestamp,
                plainTextMessage: 'Skipping because this step is paused...',
            });
            return arr;
        }
        if (!meta) {
            log('warn', {
                message: react_1.default.createElement(react_1.default.Fragment, null, "Skipping because no meta can be found..."),
                parentTimestamp,
                plainTextMessage: 'Skipping because no meta can be found...',
            });
            return arr;
        }
        if (step.type === 'findAndReplace') {
            newEl = yield steps_1.findAndReplace({
                el: newEl,
                log,
                parentTimestamp,
                step,
            });
            return [...arr, new Date()];
        }
        if (!step.selector || step.selector.trim().length === 0) {
            log('warn', {
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Skipping ",
                    meta.futureTense,
                    " because there is no selector...")),
                parentTimestamp,
                plainTextMessage: `Skipping ${meta.futureTense} because there is no selector...`,
            });
            return arr;
        }
        let nodeList;
        try {
            nodeList = newEl.querySelectorAll(step.selector);
        }
        catch (e) {
            log('error', {
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Failed to select ",
                    react_1.default.createElement("code", null, step.selector),
                    " because it is invalid.")),
                parentTimestamp,
                plainTextMessage: `Failed to select ${step.selector} because it is invalid.`,
            });
            return arr;
        }
        const elements = template_parser_1.nodeListToArray(nodeList);
        if (elements.length === 0) {
            // LOG
            log('warn', {
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Found 0 elements to ",
                    meta.futureTense,
                    " that matched",
                    ' ',
                    react_1.default.createElement("code", null, step.selector),
                    ". Continuing on...")),
                parentTimestamp,
                plainTextMessage: `Found 0 elements to ${meta.futureTense} that matched '${step.selector}'. Continuing...`,
            });
            return [...arr, new Date()];
        }
        // LOG
        log('info', {
            message: (react_1.default.createElement(react_1.default.Fragment, null,
                displayStep,
                " ",
                elements.length,
                " element",
                elements.length !== 1 && 's',
                " that matched",
                ' ',
                react_1.default.createElement("code", null, step.selector),
                "...")),
            parentTimestamp,
            plainTextMessage: `${displayStep} element${elements.length !== 1 &&
                's'} that matched ${step.selector}...`,
        });
        yield elements.reduce((responses, selectedEl) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const newResponses = yield responses;
            if (!checkIfMounted()) {
                utils_1.logger.warn('runSteps | Exiting (3) because component is no longer mounted');
                return newResponses;
            }
            parentTimestamp = parentTimestamp || new Date();
            try {
                const newChildEl = yield runStepOnElement_1.runStepOnElement(Object.assign(Object.assign({}, opts), { el: selectedEl, parentTimestamp,
                    step }));
                // Exit if component unmounted
                if (!checkIfMounted()) {
                    utils_1.logger.warn('runSteps | Exiting (4) because component is no longer mounted');
                    return newResponses;
                }
                if (newChildEl.parentElement) {
                    selectedEl.parentElement.replaceChild(newChildEl, newChildEl);
                }
            }
            catch (e) {
                utils_1.logger.error({ error: e, errorMessage: `${e}` }, e);
                log('error', {
                    message: react_1.default.createElement(react_1.default.Fragment, null, "Failed to run step"),
                    parentTimestamp,
                    plainTextMessage: 'Failed to run step',
                    previewHtml: `${e}`,
                });
            }
            return [...newResponses, new Date()];
        }), Promise.resolve([]));
        return [...arr, new Date()];
    }), Promise.resolve([])));
    return newEl;
});
//# sourceMappingURL=runStepsOnRootElement.js.map